// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".region-stamp{cursor:default;display:inline-block;white-space:nowrap}.region-stamp.code{background-color:#fff;border:1px solid #ddd;border-radius:3px;color:#000;font-size:13px;font-weight:500;line-height:20px;padding:0 6px}.region-stamp.plain{background-color:transparent;border:none;font-size:1em;font-weight:700;margin:0;padding:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
